(function(w, d) {

    var Modal = function() {

        this.inDOM = false;
        this.isVisible = false;
        this.layers = [];
        this.triggerElement = null;

    };

    Modal.prototype.getLayer = function() {
        return this.layers.length;
    };

    Modal.prototype.inject = function() {

        if(this.inDOM) {
            return;
        }

        var modal = document.createElement('div');

        modal.id = 'modal';

        modal.classList.add('modal');
        modal.classList.add('fade');

        modal.setAttribute('role', 'dialog');
        modal.setAttribute('tabindex', '-1');

        var dialog = document.createElement('div');
        dialog.classList.add('modal-dialog');

        modal.appendChild(dialog);

        d.body.insertBefore(modal, d.body.firstChild);

        this.inDOM = true;

    };

    Modal.prototype.triggerEvent = function(event, details) {

        if (details === undefined) {
            details = {};
        }

        details['triggerElement'] = this.triggerElement;

        d.getElementById('modal').dispatchEvent(new CustomEvent(event, { detail: details, bubbles: true, cancelable: false }));

    };

    Modal.prototype.show = function() {

        if(this.isVisible) {
            return;
        }

        var modal = d.getElementById('modal');

        this.triggerEvent('modal:show');

        modal.classList.add('in');
        modal.style.cssText = 'display: block; overflow-y: scroll;';

        this.isVisible = true;

    };

    Modal.prototype.hide = function() {

        if(!this.isVisible) {
            return;
        }

        var modal = d.getElementById('modal');

        this.triggerEvent('modal:hide');

        modal.classList.remove('in');
        modal.style.cssText = '';

        this.isVisible = false;

    };

    Modal.prototype.open = function(name, content, wide) {

        if (wide === undefined) {
            wide = false;
        }

        d.body.style.overflow = 'hidden';

        this.inject();
        this.pushLayer(name, content, wide);

    };

    Modal.prototype.pushLayer = function(name, content, wide) {

        this.hide();

        var currentLayer = this.layers[this.layers.length - 1],
            newLayer = currentLayer === undefined || currentLayer.name !== name;

        if(newLayer) {
            this.layers.push({ name: name, wide: wide });
        }

        var container = d.getElementById('modal').querySelector('.modal-dialog'),
            contentElement = container.querySelector('.modal-content:last-child');

        if(!newLayer) {
            contentElement.remove();
        } else if(contentElement) {
            contentElement.classList.add('hidden');
        }

        contentElement = document.createElement('div');
        contentElement.classList.add('modal-content');

        contentElement.innerHTML = content;

        if(wide) {
            container.classList.add('wide');
        } else {
            container.classList.remove('wide');
        }

        container.appendChild(contentElement);

        this.show();

        this.triggerEvent('modal:added-layer');

    };

    Modal.prototype.popLayer = function(callback) {

        if(this.getLayer() === 0) {
            return;
        }

        this.hide();

        var container = d.getElementById('modal').querySelector('.modal-dialog'),
            contentElement = container.querySelector('.modal-content:last-child');

        this.layers.pop();

        contentElement.remove();

        if(this.getLayer() > 0) {

            contentElement = container.querySelector('.modal-content:last-child');
            contentElement.classList.remove('hidden');

            var newLayer = this.layers[this.layers.length - 1];

            if(newLayer.wide) {
                container.classList.add('wide');
            } else {
                container.classList.remove('wide');
            }

        }

        this.show();

        if(callback) {
            callback.bind(this)();
        }

        this.triggerEvent('modal:removed-layer');

    };

    Modal.prototype.close = function(callback) {

        this.popLayer(callback);

        if(this.getLayer() !== 0) {
            return;
        }

        d.getElementById('modal').remove();

        this.isVisible = false;
        this.inDOM = false;
        this.triggerElement = null;

        d.body.style.overflow = '';

    };

    var modal = new Modal();

    w.Modal = modal;

    d.body.addEventListener('click', function (e) {

        if(e.target.closest('[data-toggles="modal"]')) {
            modal.triggerElement = e.target;
        } else if (e.target.closest('[data-dismisses="modal"]')) {
            modal.close();
        } else {
            return;
        }

        e.preventDefault();

    });

})(window, document);